/**
 * Single GTM container for all apps.
 * One team manages all tags — use `app_origin` and `product` dimensions in GA4
 * to segment traffic by app/product.
 */
export const GTM_ID = 'GTM-NBNJ2RX'

/**
 * Product identifier sent with every event.
 * Keep this explicit so GA4 does not collapse multiple apps into one bucket.
 */
export const APP_PRODUCT = {
  'rental-marketplace': 'rental-marketplace',
  'accounts-portal': 'accounts-portal',
  'global-portal': 'global-portal',
  landlord: 'landlord',
  sso: 'sso',
  'co-owner': 'co-owner',
} as const

/** @deprecated Use GTM_ID directly. Kept for backwards compatibility. */
export const GTM_IDS = {
  'rental-marketplace': GTM_ID,
  'accounts-portal': GTM_ID,
  'global-portal': GTM_ID,
  landlord: GTM_ID,
  sso: GTM_ID,
  'co-owner': GTM_ID,
} as const

export type AppName = keyof typeof APP_PRODUCT
export type AppProduct = (typeof APP_PRODUCT)[AppName]
